// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6149ed21","667":"19ea4b68"}[chunkId] + ".chunk.js";
};